import { v4 as uuidv4 } from 'uuid';

/** Identifies this page load, like Figma's tracking session id: a reload or another tab gets a new one. */
export const PAGE_LOAD_ID = uuidv4();

let lastLogSequenceId = 0;

/**
 * Numbers this page load's logs from 1, so `pageLoadId` plus `sequenceId` orders them. The log formatter takes one
 * per log; a caller that also needs its log's number (to tag a RUM vital with it) takes one here and passes it as
 * the log's `sequenceId`. Debug logs take a number but never reach Datadog, so Datadog shows gaps.
 */
export const nextLogSequenceId = (): number => ++lastLogSequenceId;

export const TestOnlyResetLogSequenceId = (): void => {
  lastLogSequenceId = 0;
};
